type Weights = { key: string; weight: number }

export default function weightedRandom(options: Weights[]) {
  let i

  const weights: number[] = []

  for (i = 0; i < options.length; i++) weights[i] = options[i].weight + (weights[i - 1] || 0)

  var random = Math.random() * weights[weights.length - 1]

  for (i = 0; i < weights.length; i++) if (weights[i] > random) break

  return options[i].key
}
